import React from 'react';
import { useLoadingStore } from '../../store/loadingStore';
import { LoadingScreen } from '../LoadingScreen';

export const GlobalLoading: React.FC = () => {
  const isLoading = useLoadingStore((state) => state.count > 0);
  return <LoadingScreen isLoading={isLoading} />;
};

export default GlobalLoading;
